import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "top-list" }
const _hoisted_2 = { class: "top-list__cell" }
const _hoisted_3 = {
  key: 0,
  class: "top-list__cell top-list__cell_player"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_TopListFilter = _resolveComponent("TopListFilter")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_tag_list_collapsible = _resolveComponent("tag-list-collapsible")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_TokenPagination = _resolveComponent("TokenPagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_header, { class: "top-list__header" }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createElementVNode("h2", { class: "top-list__title" }, " Top ", -1 /* CACHED */)
      ]))]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_TopListFilter),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      class: "top-list__table",
      data: _ctx.topList,
      "row-key": "rowKey",
      size: "small"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "index",
          label: "#",
          width: "40",
          align: "center",
          "class-name": "top-list__cell_index"
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.TOP_LIST_COLUMN_LIST[_ctx.activeTableType], (column) => {
          return (_openBlock(), _createBlock(_component_el_table_column, _mergeProps({
            key: column.prop
          }, { ref_for: true }, column), {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_2, [
                (_ctx.isPlayerColumn(column.prop))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_el_link, {
                        type: "primary",
                        underline: "always",
                        onClick: ($event: any) => (_ctx.openPlayerProfile(row.playerId))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(row.playerEmail), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]),
                      _createVNode(_component_tag_list_collapsible, {
                        "tag-list": row.tagList,
                        "display-limit-count": 2
                      }, null, 8 /* PROPS */, ["tag-list"])
                    ]))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: _normalizeClass(column.cellClass?.(row))
                    }, _toDisplayString(row[column.prop]), 3 /* TEXT, CLASS */))
              ])
            ]),
            _: 2 /* DYNAMIC */
          }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["data"])), [
      [_directive_loading, _ctx.isTopListLoading]
    ]),
    _createVNode(_component_TokenPagination, {
      "has-next-page": _ctx.hasNextPage,
      class: "top-list__pagination",
      "is-limit-visible": false,
      onNextPage: _ctx.clickNextPage
    }, null, 8 /* PROPS */, ["has-next-page", "onNextPage"])
  ]))
}